module.exports = __webpack_public_path__ + "static/media/WALAA ALZIR.d00c138e.png";